export const shadows = {
  light: "0 1px 4px rgba(0, 0, 0, 0.04)",
  mid: "0 2px 8px rgba(0, 0, 0, 0.08)",
  midHover: "0 6px 12px rgba(0, 0, 0, 0.12)",
  strong: "0 8px 24px rgba(0, 0, 0, 0.12)",

  inverseLight: "0px -1px 4px rgba(0, 0, 0, 0.08)",
  inverseMid: "0px -2px 8px rgba(0, 0, 0, 0.08)",
  inverseMidHover: "0px -6px 12px rgba(0, 0, 0, 0.12)",
  inverseStrong: "0px -8px 24px rgba(0, 0, 0, 0.12)",
} as const
